import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../lib/language'

// Shared public-site header (matches the locked homepage look).
// Pages using this should give their <main> the id "nsv-main" for the skip link.
export default function SiteHeader() {
  const { t } = useLanguage()
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    function onScroll() { setScrolled(window.scrollY > 20) }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const styles = `
    .nsv-skip { position:absolute; top:-100px; left:16px; background:#4D4E8D; color:#fff; padding:9px 16px; border-radius:8px; font-size:13px; font-weight:600; text-decoration:none; z-index:9999; transition:top .2s; font-family:'Plus Jakarta Sans',sans-serif; }
    .nsv-skip:focus { top:16px; }
    .nsv-nav :focus-visible, .nsv-skip:focus-visible { outline:2px solid #4D4E8D; outline-offset:3px; border-radius:6px; }

    .nsv-nav { position:sticky; top:0; z-index:100; display:flex; align-items:center; justify-content:space-between; padding:14px 44px; background:rgba(233,234,236,0.82); backdrop-filter:blur(10px); transition:box-shadow .3s, background .3s; font-family:'Plus Jakarta Sans',-apple-system,BlinkMacSystemFont,system-ui,sans-serif; }
    .nsv-nav.scrolled { background:rgba(233,234,236,0.97); box-shadow:0 1px 0 rgba(21,23,21,0.06), 0 8px 24px rgba(21,23,21,0.05); }
    .nsv-brand { display:flex; align-items:center; gap:11px; text-decoration:none; flex-shrink:0; }
    .nsv-brand img { height:72px; width:auto; object-fit:contain; }
    .nsv-brand-name { font-size:20px; font-weight:700; color:#151715; letter-spacing:-.01em; }
    .nsv-nav-links { display:flex; align-items:center; gap:26px; }
    .nsv-nav-link { color:#5C6065; font-size:14px; font-weight:500; text-decoration:none; transition:color .2s; white-space:nowrap; }
    .nsv-nav-link:hover { color:#4D4E8D; }
    .nsv-nav-cta { background:#4D4E8D; color:#fff; font-size:14px; font-weight:600; padding:9px 20px; border-radius:10px; text-decoration:none; transition:background .2s, transform .15s; white-space:nowrap; }
    .nsv-nav-cta:hover { background:#41427a; transform:translateY(-1px); }
    @media(max-width:760px){ .nsv-nav{ padding:13px 20px; } .nsv-nav-links{ gap:14px; } .nsv-nav-link{ display:none; } .nsv-brand-name{ font-size:18px; } .nsv-brand img{ height:56px; } }
  `

  return (
    <>
      <style>{styles}</style>
      <a href="#nsv-main" className="nsv-skip">Skip to main content</a>
      <nav className={`nsv-nav${scrolled ? ' scrolled' : ''}`} role="navigation" aria-label="Main navigation">
        <Link to="/" className="nsv-brand" aria-label="Notary Signing Vault, LLC homepage">
          <img src="/nsv_logo.png?v=2" alt="Notary Signing Vault, LLC — Nationwide Notary Professionals Network" onError={e => { e.target.style.display = 'none' }} />
        </Link>
        <div className="nsv-nav-links">
          <Link to="/" className="nsv-nav-link">{t('nav_home')}</Link>
          <Link to="/services" className="nsv-nav-link">{t('nav_services')}</Link>
          <Link to="/about" className="nsv-nav-link">{t('nav_about')}</Link>
          <Link to="/contact" className="nsv-nav-link">{t('nav_contact')}</Link>
          <Link to="/login" className="nsv-nav-cta" aria-label="Sign in to your existing account.">{t('nav_signin')}</Link>
        </div>
      </nav>
    </>
  )
}
